import styled from 'styled-components'
import ScanBar from '../../../../../../generic/ui/Input/ScanBar'
import PalletTypeToggle from './PalletTypeToggle'

type Props = {
  palletNumber: string
  onPalletNumberChange: (value: string) => void
  onScan: (value: string) => void
  isExternal: boolean
  onToggle: (isExternal: boolean) => void
}

/** Internal/external segmented toggle + barcode scan field for the pallet number. */
const PalletLookupField = ({
  palletNumber,
  onPalletNumberChange,
  onScan,
  isExternal,
  onToggle,
}: Props) => (
  <Wrap>
    <PalletTypeToggle isExternal={isExternal} onToggle={onToggle} />
    <ScanBar
      value={palletNumber}
      onChange={onPalletNumberChange}
      onScan={onScan}
      placeholder='הכנס / סרוק מספר משטח'
    />
  </Wrap>
)

export default PalletLookupField

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  align-items: stretch;
`
